import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ControlledTable from "../../../component/ControlledTable";
import { useDispatch, useSelector } from "react-redux";
import { salesListTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import {
  createCommission,
  getCompanyList,
  getPartners,
} from "../../../api/commissions";
import {
  createSales,
  getIndustryList,
  getSalesList,
  getStageList,
} from "../../../api/sales";
import { makeStyles } from "@material-ui/core";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import { getPartnersDropdownList } from "../../../api/partnerList";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));

export default function LeadsList() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [company, setCompany] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [industry, setIndustry] = useState("");
  const [companyListData, setCompanyListData] = useState([]);
  const [industryListData, setIndustryListData] = useState([]);
  const [stageListData, setStageListData] = useState([]);
  const [stage, setStage] = useState("");
  const [priority, setPriority] = useState("");
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  addAdditionalColumn(obj, dispatch);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.lead_id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    refreshTable();
  }, [company, industry, priority, stage, partnerName]);
  const getRows = async (numRows, startRow) => {
    return getSalesList(
      {
        partnername: "",
        companyname: "",
        industry: "",
        priority: "",
        stage: "",
        limit: numRows,
        offset: startRow,
      },
      user.token
    )
      .then((res) => {
        setTotalCount(parseInt(res.data.total) === 0 ? -1 : res.data.total);
        return res.data.records;
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        return [];
      });
  };
  const refreshTable = async () => {
    try {
      const { data } = await getSalesList(
        {
          partnername: partnerName,
          companyname: company,
          industry: industry,
          priority: priority,
          stage: stage,
          limit: 10,
          offset: 0,
        },
        user.token
      );
      setTotalCount(parseInt(data.total) === 0 ? -1 : parseInt(data.total));
      setRows(data.records);
    } catch (err) {
      handleAxiosError(err, dispatch);
    }
  };
  useEffect(() => {
    industryList();
    companyList();
    stageList();
  }, []);
  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function companyList() {
    try {
      const { data } = await getCompanyList(user.token);
      setCompanyListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  async function stageList() {
    try {
      const { data } = await getStageList(user.token);
      setStageListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">Leads</Typography>
        </Box>

        {user.role === "Partner" ? (
          <Button
            variant="contained"
            style={{ padding: "5px 7px" }}
            onClick={() => {
              setCreateDialogOpen(true);
            }}
            className="blue-button"
          >
            Add New Lead
          </Button>
        ) : (
          <></>
        )}
      </Box>
      <br />
      <Box className="pmt-filter-box">
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item lg={2} md={2} sm={4} xs={12}>
            <TextField
              className={classes.textfeild}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={partnerName}
              label="Partner Name"
              size="small"
              fullWidth
              onChange={(e) => {
                setPartnerName(e.target.value);
              }}
            />
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Company Name
              </InputLabel>
              <Select
                MenuProps={{ className: "select-box-height" }}
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={company}
                label="Company Name"
                size="small"
                sx={{ background: "#fff" }}
                onChange={(e) => {
                  setCompany(e.target.value);
                }}
              >
                <MenuItem value="">Select</MenuItem>
                {companyListData.map((c, i) => (
                  <MenuItem key={i} value={c.company_name}>
                    {c.company_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Industry
              </InputLabel>
              <Select
                MenuProps={{ className: "select-box-height" }}
                sx={{ background: "#fff" }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size="small"
                value={industry}
                label="Industry"
                onChange={(e) => {
                  setIndustry(e.target.value);
                }}
              >
                <MenuItem value="">Select</MenuItem>
                {industryListData.map((c, i) => (
                  <MenuItem key={i} value={c.industry_display_value}>
                    {c.industry_display_value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Priority
              </InputLabel>
              <Select
                MenuProps={{ className: "select-box-height" }}
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={priority}
                label="Priority"
                size="small"
                sx={{ background: "#fff" }}
                onChange={(e) => {
                  setPriority(e.target.value);
                }}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
                <MenuItem value="4">4</MenuItem>
                <MenuItem value="5">5</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={2} md={2} sm={4} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label" size="small">
                Stage
              </InputLabel>
              <Select
                MenuProps={{ className: "select-box-height" }}
                className={classes.textfeild}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={stage}
                label="Stage"
                size="small"
                sx={{ background: "#fff" }}
                onChange={(e) => {
                  setStage(e.target.value);
                }}
              >
                <MenuItem value="">Select</MenuItem>
                {stageListData.map((s, i) => (
                  <MenuItem key={i} value={s.stage_display}>
                    {s.stage_display}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      {/* <br /> */}
      <div className="pmt-controll-table">
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div>
      <AddNewLeadDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      minWidth: 65,
      maxWidth: 70,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            dispatch({ type: "VIEW", data: params.data });
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }
}
const emptyNewLeadData = {
  company_name: "",
  email: "",
  linkedin_url: "",
  industry_value: "",
  project_name: "",
  priority: "",
  contact: "",
  stage_value: "",
  probability: "",
  address: "",
  project_description: "",
  estimated_budget: "",
  key_stakeholder: "",
  estimated_close_date: "",
};
function AddNewLeadDialog({ open, setOpen, onRefresh }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewLeadData);
  const [stageListData, setStageListData] = useState([]);
  const [IndustryListData, setIndustryListData] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewLeadData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewLeadData);
    }
  }, [open]);

  async function onNewLeadSubmit(newdata) {
    try {
      const { data } = await createSales(newdata, user.token);
      dispatch(showAlert(data.msg));
      setOpen(false);
      onRefresh();
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }
  useEffect(() => {
    industryList();
    stageList();
  }, []);
  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function stageList() {
    try {
      const { data } = await getStageList(user.token);
      setStageListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        // setOpen(false);
      }}
    >
      <DialogTitle>Create New Lead</DialogTitle>
      <Box component="form" onSubmit={onNewLeadSubmit}>
        <DialogContent>
          <Grid container spacing={2} sx={{ pt: "1rem" }}>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth required error={Boolean(errors.industry_value)}>
                <InputLabel id="demo-simple-select-label-a">
                  Industry
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select MenuProps={{ className: "select-box-height" }} value={props.value} onChange={props.onChange}>
                      {IndustryListData.map((c, i) => (
                        <MenuItem key={i} value={c.industry_value}>
                          {c.industry_display_value}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="industry_value"
                  control={control}
                  rules={{
                    required: "Please select Industry value",
                  }}
                />
                <FormHelperText>
                  {errors.industry_value?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth required error={Boolean(errors.stage_value)}>
                <InputLabel id="demo-simple-select-label-a">Stage</InputLabel>
                <Controller
                  render={(props) => (
                    <Select MenuProps={{ className: "select-box-height" }} value={props.value} onChange={props.onChange}>
                      {stageListData.map((s, i) => (
                        <MenuItem key={i} value={s.stage_value}>
                          {s.stage_display}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="stage_value"
                  control={control}
                  rules={{
                    required: "Please select Stage value",
                  }}
                />
                <FormHelperText>{errors.stage_value?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth required error={Boolean(errors.priority)}>
                <InputLabel id="demo-simple-select-label-a">
                  Priority
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select MenuProps={{ className: "select-box-height" }} value={props.value} onChange={props.onChange}>
                      <MenuItem value="1">1</MenuItem>
                      <MenuItem value="2">2</MenuItem>
                      <MenuItem value="3">3</MenuItem>
                      <MenuItem value="4">4</MenuItem>
                      <MenuItem value="5">5</MenuItem>
                    </Select>
                  )}
                  name="priority"
                  control={control}
                  rules={{
                    required: "Please select priority value",
                  }}
                />
                <FormHelperText>{errors.priority?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="company_name"
                fullWidth
                label="Company"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Company is required.",
                })}
                required
                error={Boolean(errors.company_name)}
                helperText={errors.company_name?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="email"
                fullWidth
                label="Email"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Email Address  is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                required
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="linkedin_url"
                fullWidth
                label="LinkedIn URL"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "LinkedIn URL is required.",
                  pattern: {
                    value:
                      /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/,
                    message: "Please enter a valid linkedin url.",
                  },
                })}
                required
                error={Boolean(errors.linkedin_url)}
                helperText={errors.linkedin_url?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="project_name"
                fullWidth
                label="Project Name"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Project name is required.",
                })}
                required
                error={Boolean(errors.project_name)}
                helperText={errors.project_name?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="contact"
                fullWidth
                label="Contact"
                type="tel"
                inputProps={{ maxLength: 10 }}
                variant="outlined"
                inputRef={register({
                  required: "Contact Number is required.",
                  validate: (value) =>
                    value.length > 9 || "Please enter a valid number",
                })}
                required
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="probability"
                fullWidth
                label="Probability"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: "Probability is required.",
                })}
                required
                error={Boolean(errors.probability)}
                helperText={errors.probability?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="address"
                fullWidth
                label="Address"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Address is required.",
                })}
                required
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="project_description"
                fullWidth
                label="Project description"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Project description is required.",
                })}
                required
                error={Boolean(errors.project_description)}
                helperText={errors.project_description?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="estimated_budget"
                fullWidth
                label="Estimated Budget"
                type="number"
                variant="outlined"
                inputRef={register({
                  required: "Estimated budget is required.",
                })}
                required
                error={Boolean(errors.estimated_budget)}
                helperText={errors.estimated_budget?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="key_stakeholder"
                fullWidth
                label="Key Stakeholder"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Key stakeholder is required.",
                })}
                required
                error={Boolean(errors.key_stakeholder)}
                helperText={errors.key_stakeholder?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                required
                fullWidth
                error={Boolean(errors.estimated_close_date)}
              >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        shouldDisableDate={disablePrevDates(
                          dayjs(new Date()).subtract(1, "days").toJSON()
                        )}
                        label="Estimated Close Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                          required
                            error={Boolean(errors.estimated_close_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: "Estimated Close Date  is required.",
                    }}
                    name="estimated_close_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>
                  {errors.estimated_close_date?.message}
                </FormHelperText>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit(onNewLeadSubmit)} type="submit" className="blue-button">
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
